(function () {
  'use strict';

  function initStockistsSection(wrapper) {
    if (!wrapper || wrapper.dataset.stockistsInitialized === 'true') return;
    wrapper.dataset.stockistsInitialized = 'true';

    var fadeInEnabled = wrapper.dataset.fadeIn === 'true';
    var smoothScrollEnabled = wrapper.dataset.smoothScroll === 'true';

    if (smoothScrollEnabled) {
      wrapper.style.scrollBehavior = 'smooth';
      document.documentElement.style.scrollBehavior = 'smooth';
    }

    if (!fadeInEnabled) return;

    var animatedEls = wrapper.querySelectorAll('[data-animate]');
    if (!animatedEls.length) return;

    if (!('IntersectionObserver' in window)) {
      animatedEls.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry, index) {
          if (entry.isIntersecting) {
            var delay = index * 80;
            setTimeout(function () {
              entry.target.classList.add('is-visible');
            }, delay);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    animatedEls.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initAll() {
    document.querySelectorAll('.stockists-wrapper').forEach(initStockistsSection);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initAll();
  }

  // Theme editor support: re-init on section load/reorder
  document.addEventListener('shopify:section:load', function (event) {
    var wrapper = event.target.querySelector('.stockists-wrapper');
    if (wrapper) {
      wrapper.dataset.stockistsInitialized = 'false';
      initStockistsSection(wrapper);
    }
  });
})();